import React from "react";
import { useLocation } from "react-router-dom";
import { getImageUrl } from "../../utils/Helper";
import MainComponentWrapper from "../Common/MainComponentWrapper";
import Layout from "../Layout";

const getStatusBadgeClass = (status = "") => {
  const normalized = String(status).toLowerCase();
  if (["active", "checkedin", "checked-in", "check-in"].includes(normalized)) {
    return "is-positive";
  }
  if (["checkout", "checkedout", "checked-out", "check-out"].includes(normalized)) {
    return "is-checkout";
  }
  if (["cancelled", "canceled", "inactive"].includes(normalized)) {
    return "is-cancelled";
  }
  return "is-neutral";
};

const EarningAttendeeList = ({ isError, isLoading }) => {
  const location = useLocation();
  const attendees = location.state?.attendees || [];

  return (
    <Layout
      BackAction={`/organizer/myEarning/${location.state?.eventId}?redirectUrl=/organizer/myEarning`}
      Heading="Attendees List"
      TitleMark={true}
      TitleMarkClassName="event-earning-attendees-title-mark"
      TitleClassName="event-earning-attendees-title"
      HeadClassName="event-earning-attendees-head"
      DetailsHead
      ExtraclassName="event-earning-attendees-panel"
      activeMenuId="my-earnings"
    >
      <MainComponentWrapper Loading={isLoading} errorInfo={isError}>
        <div className="event-earning-detail-body">
          <div className="event-earning-attendees-table-wrap">
            <table className="event-earning-attendees-table">
              <thead>
                <tr>
                  <th scope="col">Attendee Photo</th>
                  <th scope="col">Attendee Name</th>
                  <th scope="col">Email</th>
                  <th scope="col" className="is-status">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody>
                {attendees.length > 0 ? (
                  attendees.map((attendee, index) => (
                    <tr
                      key={attendee?._id || index}
                      className="event-my-earnings-row"
                    >
                      <td>
                        <img
                          className="event-earning-attendees-photo"
                          src={
                            attendee?.photo?.length
                              ? getImageUrl(attendee.photo[0]?.path)
                              : "/event/assets/img/sellingevents.png"
                          }
                          alt={attendee?.name || "Attendee"}
                        />
                      </td>
                      <td>{attendee?.name || ""}</td>
                      <td>{attendee?.email || ""}</td>
                      <td className="is-status">
                        <span
                          className={`event-attendee-detail-status-badge ${getStatusBadgeClass(
                            attendee?.status
                          )}`}
                        >
                          {attendee?.status || "—"}
                        </span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4}>
                      <div className="event-earning-attendees-not-found">
                        No attendees found
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </MainComponentWrapper>
    </Layout>
  );
};

export default EarningAttendeeList;
